// src/components/Profile/ProfileBack.jsx
import React from 'react';
import { FileBadge, Globe2, Database, Activity, Award, Settings } from 'lucide-react';
import PillList           from './PillList';
import InfoRow            from './InfoRow';

const ProfileBack = ({ p = {} }) => {
  const {
    emrExperience               = [],
    areasOfProficiency          = [],
    professionalCertifications  = [],
    activeCertifications        = [],
    stateAPRNLicenses           = [],
    stateLicenses               = [],
    facilityPreferences: {
      careTeamModel     = '—',
      preferredSettings = []
    } = {},
  } = p;

  // combine APRN + RN licenses, but remember which is which
  const combinedLicenses = [...stateAPRNLicenses, ...stateLicenses];
  const licenseTooltip = it => {
    if (stateAPRNLicenses.includes(it)) {
      return `State APRN license: ${it}`;
    }
    if (stateLicenses.includes(it)) {
      return `State RN license: ${it}`;
    }
    return it;
  };

  return (
    <div className="card-face-content" role="region" aria-label="Profile Back">
      <InfoRow Icon={Database}>
        <PillList
          items={emrExperience.length ? emrExperience : ['—']}
          getTooltip={it => `EMR: experience with ${it}`}
          idPrefix="emr"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={Activity}>
        <PillList
          items={areasOfProficiency.length ? areasOfProficiency : ['—']}
          getTooltip={it => `Proficient in ${it} cases`}
          idPrefix="proficiency"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={Award}>
        <PillList
          items={[...professionalCertifications, ...activeCertifications].length
            ? [...professionalCertifications, ...activeCertifications]
            : ['—']}
          getTooltip={it => `Certification: ${it}`}
          idPrefix="certifications"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={FileBadge}>
        <PillList
          items={combinedLicenses.length ? combinedLicenses : ['—']}
          getTooltip={licenseTooltip}
          idPrefix="licenses"
        />
      </InfoRow>
      <hr className="hand-drawn-divider" />

      <InfoRow Icon={Settings}>
        <PillList
          items={[careTeamModel, ...preferredSettings].filter(Boolean)}
          getTooltip={it => `Preference: ${it}`}
          idPrefix="preferences"
        />
      </InfoRow>
    </div>
  );
};

export default ProfileBack;
